import React, { useState } from 'react';
import { Card, Modal } from "react-bootstrap";
import { TFunction, withTranslation } from 'react-i18next';
import Form from '../containers/form';
import "./form.scss";
import Button from '../controls/buttons/button';
import SubmitButton from '../controls/buttons/submitButton';
import { ReactComponent as IconTrashSVG } from "itd-common/assets/icons/trash.svg";
import { ReactComponent as IconFiltersSVG } from "itd-common/assets/icons/icon-filters.svg";
import { ReactComponent as IconCloseSVG } from "itd-common/assets/icons/close.svg";
import { UtilService } from '../../services/UtilService';
import { WebCache } from '../../services/WebCache';

interface IProps {
    header?: React.ReactElement,
    children: React.ReactElement,
    onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void,
    clear?: () => void,
    model?: any,
    hidden?: Boolean,
    t: TFunction
}

const FormFilter = ({ header, hidden, children, onSubmit, clear, model, t }: IProps) => {
    const [hiddenModal, setHiddenModal] = useState(true);
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (onSubmit) {
        hidden && setHiddenModal(true);
        onSubmit(event);
    }
    }

return (
    <div className={`filter-accordion form-filter ${UtilService.isMobilePlatform() && 'my-4'}`}>
        <>
            <Modal show={!hiddenModal} size='lg' scrollable centered onHide={() => setHiddenModal(true)} dialogClassName={WebCache.isPosnetAppUser() ? 'isPosnetAppUser' : ''}>
                <Modal.Header className='border-0 pb-0 align-items-start'>
                    <div className='filters-title p-0'>
                        <h3 className='mb-1'>{t('filters')}</h3>
                        <p className='text-gray mb-0'>{t('elementsSelectedSearch')}</p>
                    </div>
                    <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button'})} className='ms-2' onClick={()=> setHiddenModal(true)}>
                        <IconCloseSVG ></IconCloseSVG>
                    </a>
                </Modal.Header>
                <Modal.Body className='div-form-filter'>
                    <Form onSubmit={handleSubmit} model={model}>
                        <div className='d-flex flex-column'>
                            <section>
                                {children}
                            </section>
                            <div className='d-flex flex-wrap justify-content-end align-items-center mt-4'>
                                { !clear ||
                                <a{...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )} className='fw-bold d-flex align-items-center me-4 clear-filter' onClick={clear}>
                                    {t('clear')} <IconTrashSVG className='ms-2'></IconTrashSVG>
                                </a>
                                }
                                <SubmitButton label="query" className={`applyFilter m-0 ${UtilService.isMobilePlatform()?'submitNative':''}`}></SubmitButton>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            { hidden ? // si el parametro hidden viene true, se oculta los filtros y cuando se hace click en el icono. se muestran en un modal
                <>
                    {WebCache.isPosnetAppUser() 
                        ? <div className="col-md-10">
                            <Button noBlock noMargin onClick={() => setHiddenModal(false)} label='Filtros'></Button>
                        </div>
                        : 
                        <a
                            {...(UtilService.isMobilePlatform() && { type: 'button' } )}
                            onClick={() => setHiddenModal(false)}
                        >
                            <IconFiltersSVG></IconFiltersSVG>
                        </a>
                    }
                </>
                : 
                <div className="filter-accordion mb-4">
                    <Form onSubmit={handleSubmit} model={model}>
                    <>
                        {header}
                        {children}
                        <div className="row mt-5 justify-content-end"> 
                            <div className="col-md-12 col-lg-6 d-flex justify-content-end">
                                { !clear ||
                                <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )} className='fw-bold d-flex align-items-center pe-4' onClick={clear}>
                                    {t('clear')} <IconTrashSVG className='ps-1'></IconTrashSVG>
                                </a>
                                }
                                <SubmitButton className="applyFilter m-0" label="query"></SubmitButton>
                            </div>
                        </div>
                    </>
                    </Form>
                </div>
            }
        </>
        </div>
    );
};

export default withTranslation()(FormFilter);
